<div class="fixed inset-0 z-50 overflow-y-auto  " aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0">

        <!-- Backdrop with stronger blur -->
        <div class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity duration-300 ease-out"
            [class.opacity-100]="isVisible" [class.opacity-0]="!isVisible" (click)="onClose()"></div>

        <!-- Main Modal Container -->
        <div class="z-50 relative inline-block align-bottom bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl rounded-[2rem] text-left overflow-hidden shadow-2xl shadow-amber-500/10 transform transition-all duration-300 ease-out sm:my-8 sm:align-middle sm:max-w-4xl w-full border border-white/20 dark:border-slate-700/50"
            [class.opacity-100]="isVisible" [class.opacity-0]="!isVisible" [class.translate-y-0]="isVisible"
            [class.translate-y-4]="!isVisible" [class.sm:scale-100]="isVisible" [class.sm:scale-95]="!isVisible">

            <!-- Premium Header -->
            <div
                class="relative px-8 py-6 border-b border-gray-100 dark:border-slate-800 flex justify-between items-start sticky top-0 z-20 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md">

                <!-- Decorative background elements -->
                <!-- <div
                    class="absolute top-0 right-0 w-64 h-64 bg-amber-400/10 rounded-full blur-3xl -z-10 translate-x-1/2 -translate-y-1/2">
                </div>
                <div
                    class="absolute bottom-0 left-0 w-48 h-48 bg-yellow-300/10 rounded-full blur-2xl -z-10 -translate-x-1/2 translate-y-1/2">
                </div> -->

                <div class="relative z-10 flex gap-4 items-center">
                    <div
                        class="p-3 bg-yellow-500/80 dark:bg-yellow-500 rounded-2xl shadow-lg shadow-amber-500/20 text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 tracking-tight"
                            id="modal-title">
                            รายละเอียดรายการจอด
                        </h3>
                        <div class="flex items-center gap-3 mt-1.5" *ngIf="data">
                            <span
                                class="text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-widest">Invoice
                                No.</span>
                            <span
                                class="text-sm font-bold text-amber-700 dark:text-amber-400 bg-amber-100/50 dark:bg-amber-900/30 px-3 py-1 rounded-lg border border-amber-200/50 dark:border-amber-800/50 shadow-sm">{{
                                invoice || '-' }}</span>
                        </div>
                    </div>
                </div>
                <!-- Close Button -->
                <button (click)="onClose()"
                    class="relative z-10 group cursor-pointer bg-gray-50 dark:bg-slate-800 hover:bg-amber-50 dark:hover:bg-amber-900/30 border border-gray-200 dark:border-slate-700 rounded-xl p-2.5 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 hover:shadow-md hover:border-amber-200 dark:hover:border-amber-700">
                    <span class="sr-only">Close</span>
                    <svg class="h-5 w-5 text-gray-400 dark:text-slate-500 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <!-- Body Content -->
            <div class="p-8 max-h-[65vh] overflow-y-auto scroll-smooth custom-scrollbar" *ngIf="!isLoading">

                <!-- General Info Card -->
                <div
                    class="relative bg-white dark:bg-slate-800/80 rounded-[1.5rem] shadow-sm border border-gray-100 dark:border-slate-700/60 p-7 mb-8 overflow-hidden group hover:shadow-md transition-shadow duration-300">
                    <!-- Subtle hover gradient background -->
                    <div
                        class="absolute inset-0 bg-gradient-to-br from-amber-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10 dark:from-amber-900/10">
                    </div>

                    <div
                        class="flex flex-col sm:flex-row sm:items-center justify-between mb-8 pb-5 border-b border-gray-100/80 dark:border-slate-700/80 gap-4 relative z-10">
                        <h4 class="text-lg font-bold text-gray-800 dark:text-white flex items-center gap-3">
                            <span class="w-1.5 h-6 bg-yellow-500/50 rounded-full"></span>
                            ข้อมูลทั่วไป
                        </h4>

                        <!-- Status Badge -->
                        <span [ngClass]="{
                            'bg-gray-100/80 text-gray-700 border-gray-300 dark:bg-slate-800 dark:text-gray-300 dark:border-slate-600': status === 3,
                            'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/40 dark:text-amber-400 dark:border-amber-800/50': status === 1,
                            'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/40 dark:text-emerald-400 dark:border-emerald-800/50': status === 2,
                            'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/40 dark:text-red-400 dark:border-red-800/50': status === 0
                        }"
                            class="inline-flex items-center px-4 py-1.5 rounded-xl text-xs font-bold border shadow-sm backdrop-blur-sm">
                            <span class="relative flex h-2 w-2 mr-2.5">
                                <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75"
                                    [ngClass]="{
                                    'bg-gray-400': status === 3,
                                    'bg-amber-500': status === 1,
                                    'bg-emerald-500': status === 2,
                                    'bg-red-500': status === 0
                                }"></span>
                                <span class="relative inline-flex rounded-full h-2 w-2" [ngClass]="{
                                    'bg-gray-500 dark:bg-gray-400': status === 3,
                                    'bg-amber-600 dark:bg-amber-500': status === 1,
                                    'bg-emerald-500 dark:bg-emerald-400': status === 2,
                                    'bg-red-500 dark:bg-red-400': status === 0
                                }"></span>
                            </span>
                            {{ status === 3 ? 'บันทึกโครง (Draft)'
                            : (status === 1 ? 'รอตรวจสอบ (Pending)'
                            : ( status === 2 ? 'ยืนยันแล้ว (Confirmed)'
                            : 'ยกเลิก (Cancelled)')) }}
                        </span>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-8 gap-x-10 relative z-10">
                        <div class="space-y-1.5">
                            <p
                                class="text-[11px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest">
                                ชื่อรายการ</p>
                            <p class="text-sm font-semibold text-gray-900 dark:text-slate-200 truncate">{{ name || '-'
                                }}</p>
                        </div>
                        <div class="space-y-1.5">
                            <p
                                class="text-[11px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest">
                                Client / ร้าน</p>
                            <p class="text-sm font-semibold text-gray-900 dark:text-slate-200 truncate">{{
                                data?.clientName || '-' }}</p>
                        </div>
                        <div class="space-y-1.5">
                            <p
                                class="text-[11px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest">
                                ชื่อลูกค้า</p>
                            <p class="text-sm font-semibold text-gray-900 dark:text-slate-200 truncate">{{
                                data?.customerName || '-' }}</p>
                        </div>
                        <div class="space-y-1.5">
                            <p
                                class="text-[11px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest">
                                ชื่อค่าธรรมเนียม</p>
                            <p
                                class="text-sm font-semibold text-gray-900 dark:text-slate-200 truncate flex items-center gap-2">
                                <span class="w-1.5 h-1.5 rounded-full bg-amber-400"></span>
                                {{ data?.feeName || '-' }}
                            </p>
                        </div>

                        <!-- Total Fee Card Highlight -->
                        <div
                            class="bg-gradient-to-br from-amber-50 to-yellow-50/50 dark:from-amber-900/20 dark:to-slate-800 -mx-3 px-4 py-3 rounded-2xl border border-amber-200/60 dark:border-amber-800/30 shadow-sm relative overflow-hidden group/fee">
                            <div
                                class="absolute right-0 top-0 w-24 h-24 bg-gradient-to-br from-yellow-400/20 to-transparent rounded-bl-full -z-10 group-hover/fee:scale-110 transition-transform duration-500">
                            </div>
                            <p
                                class="text-[11px] font-bold text-amber-600 dark:text-amber-500 uppercase tracking-widest mb-1">
                                ยอดรวมค่าธรรมเนียม</p>
                            <div class="flex items-baseline gap-1.5">
                                <p class="text-xl font-black text-amber-800 dark:text-amber-400 tracking-tight">{{
                                    totalFee | number:'1.2-2' }}</p>
                                <span class="text-xs text-amber-600 dark:text-amber-500 font-bold uppercase">THB</span>
                            </div>
                        </div>

                        <div class="space-y-1.5 pt-2">
                            <p
                                class="text-[11px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest">
                                วันที่สร้าง</p>
                            <p
                                class="text-sm font-semibold text-gray-900 dark:text-slate-200 flex items-center gap-2 bg-gray-50/50 shadow-sm dark:bg-slate-800/80 w-max px-3 py-1.5 rounded-xl  dark:border-slate-700/50">
                                <svg class="w-4 h-4 text-amber-500" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                {{ createDate | date:'dd/MM/yyyy HH:mm' }}
                            </p>
                        </div>

                        <div class="space-y-1.5 pt-2">
                            <p
                                class="text-[11px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest mb-1.5">
                                ประเภทการสมัคร
                            </p>
                            <span
                                [class]="registerType === 1 ? 'text-emerald-800 dark:text-emerald-400 dark:border-emerald-800/50 bg-emerald-100/20' : ' text-amber-800  dark:text-amber-400 dark:border-amber-800/50'"
                                class="inline-flex items-center px-3 py-1.5 rounded-xl text-xs font-bold shadow-sm">
                                <div class="w-1.5 h-1.5 rounded-full mr-1.5"
                                    [class]="registerType === 1 ? 'bg-emerald-500' : 'bg-amber-500'"></div>
                                {{ registerType === 1 ? 'สมัครใหม่' : 'ต่ออายุ' }}
                            </span>
                        </div>

                        <div class="space-y-1.5 pt-2">
                            <p
                                class="text-[11px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest mb-1.5">
                                Full Tax</p>
                            <span
                                [class]="data?.fullTax 
                                ? 'emerald-100/80 text-emerald-800 dark:emerald-900/30 dark:text-emerald-400 dark:border-emerald-800/50 border-emerald-200/80 dark:border-emerald-700' 
                                : 'gray-100/50 text-gray-600  dark:slate-800 dark:text-slate-300 dark:border-slate-700 border-gray-200/80 dark:border-slate-700'"
                                class="inline-flex items-center px-3 py-1.5 rounded-xl text-xs font-bold border-b ">
                                <div class="w-1.5 h-1.5 rounded-full mr-1.5"
                                    [class]="data?.fullTax ? 'bg-emerald-500' : 'bg-gray-400'"></div>
                                {{ data?.fullTax ? 'ขอใบกำกับภาษี' : 'ไม่ขอใบกำกับภาษี' }}
                            </span>
                        </div>

                        <div
                            class="col-span-full border-t border-gray-100 dark:border-slate-700/80 pt-6 mt-4 grid grid-cols-1 md:grid-cols-2 gap-8 relative">
                            <div class="space-y-1.5">
                                <p
                                    class="text-[11px] font-bold text-gray-400 dark:text-slate-800 uppercase tracking-widest">
                                    Receipt ID</p>
                                <div class="flex items-center px-3 py-2 rounded-xl bg-gray-50 w-max shadow-inner">
                                    <svg class="w-4 h-4 text-gray-400 mr-2" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                    <p
                                        class="text-sm font-mono font-medium text-gray-700 dark:text-slate-800 tracking-wider">
                                        {{ data?.receiptId || '-' }}
                                    </p>
                                </div>
                            </div>
                            <div class="space-y-1.5">
                                <p
                                    class="text-[11px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest">
                                    รายละเอียดเพิ่มเติม</p>
                                <p
                                    class="text-sm text-gray-600 dark:text-slate-400 leading-relaxed bg-gray-50/50 dark:bg-slate-900/30 p-3 rounded-xl border border-transparent dark:border-slate-800/50">
                                    {{ description || '-' }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Vehicles Section Header -->
                <div class="flex items-center justify-between mb-5 px-2 mt-10">
                    <h4 class="text-xl font-bold text-gray-800 dark:text-white flex items-center gap-3">
                        <div
                            class="p-2 bg-gradient-to-br from-amber-200 to-yellow-500/50 dark:from-amber-200/50 dark:to-yellow-500/30 rounded-xl shadow-inner border border-amber-200/50 dark:border-amber-800/50">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white text-yellow-600"
                                fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                        </div>
                        รายการทะเบียน
                        <span
                            class="inline-flex items-center justify-center bg-yellow-500/30 dark:bg-yellow-900/40 text-yellow-800 dark:text-yellow-400 text-sm font-bold px-2.5 py-0.5 rounded-lg border border-yellow-200 dark:border-yellow-800 shadow-sm ml-2">
                            {{ totalVehicles || 0 }} คัน
                        </span>
                    </h4>
                </div>

                <!-- Vehicles List (Modern Flex/Grid Layout instead of simple table) -->
                <div
                    class="overflow-hidden rounded-2xl border border-gray-100 mb-5 dark:border-slate-700/60 shadow-sm bg-white dark:bg-slate-800/90 backdrop-blur-md">

                    <!-- Header (Visible only on lg screens) -->
                    <div
                        class="hidden lg:grid grid-cols-[60px_2.5fr_1.5fr_1.5fr_1fr] gap-4 px-6 py-4 bg-gray-50/80 dark:bg-slate-900/50 border-b border-gray-100 dark:border-slate-700/80 text-[11px] font-bold text-gray-500 dark:text-slate-400 uppercase tracking-widest text-left">
                        <div class="text-center">#</div>
                        <div>ข้อมูลสมาชิก / โปรโมชั่น</div>
                        <div>ทะเบียนรถ</div>
                        <div>ระยะเวลา</div>
                        <div class="text-right">ราคา(FEE)</div>
                    </div>

                    <!-- Body List -->
                    <div class="max-h-[50vh] overflow-y-auto custom-scrollbar overflow-x-hidden p-3 space-y-3">

                        <!-- Empty State -->
                        <div *ngIf="!data?.cityParkingRegisterDetailMemberGroupResponse || data?.cityParkingRegisterDetailMemberGroupResponse?.length === 0"
                            class="py-16 flex flex-col items-center justify-center gap-3 text-center text-gray-400 dark:text-slate-500 bg-gray-50/30 dark:bg-slate-800/30 rounded-xl">
                            <div class="p-4 bg-gray-100 dark:bg-slate-700/50 rounded-full">
                                <svg class="w-8 h-8 text-gray-400 dark:text-slate-500" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414a1 1 0 00-.707-.293H4" />
                                </svg>
                            </div>
                            <span class="font-medium">ไม่พบรายการสมาชิก</span>
                        </div>

                        <!-- List Item (Animated) -->
                        <div *ngFor="let member of data?.cityParkingRegisterDetailMemberGroupResponse; let i = index"
                            class="animate-fade-in-up flex flex-col lg:grid lg:grid-cols-[60px_2.5fr_1.5fr_1.5fr_1fr] gap-4 items-center bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-[1rem] px-4 py-3 hover:shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:border-amber-200 dark:hover:border-amber-700/50 transition-all duration-300 group"
                            [style.animation-delay]="(i * 50) + 'ms'">

                            <!-- # -->
                            <div
                                class="w-full lg:w-auto flex lg:justify-center items-center pb-3 lg:pb-0 border-b border-gray-100 lg:border-none dark:border-slate-700">
                                <span
                                    class="lg:hidden text-[11px] font-bold text-gray-400 mr-2 uppercase tracking-widest">ลำดับ
                                    #</span>
                                <div
                                    class="w-8 h-8 rounded-full bg-gray-50 dark:bg-slate-700/50 text-gray-500 dark:text-slate-400 font-mono text-xs font-bold flex items-center justify-center border border-gray-100 shadow dark:border-slate-600 group-hover:bg-amber-50 group-hover:text-amber-600 group-hover:border-amber-200 transition-colors ml-auto lg:ml-0">
                                    {{ (i + 1) | number:'2.0' }}
                                </div>
                            </div>

                            <!-- Info -->
                            <div class="w-full flex-col flex items-start justify-center gap-2">

                                <div class="flex flex-wrap gap-2">
                                    <span
                                        class="font-bold text-gray-700 dark:text-white text-sm group-hover:text-amber-700 transition-colors flex items-center gap-2">
                                        {{ member.name || 'ไม่ระบุชื่อ' }}
                                        <!-- <svg *ngIf="member.name" class="w-4 h-4 text-blue-500" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                                    </svg> -->
                                    </span>
                                    <span
                                        class="inline-flex shadow-inner items-center gap-1.5 bg-gray-50 dark:bg-slate-700 text-gray-600 dark:text-slate-300 px-2 py-1 rounded-full text-[11px] font-medium border border-gray-200 dark:border-slate-600 hover:bg-gray-100 transition-colors">
                                        <svg class="w-3.5 h-3.5 " fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                        </svg>
                                        {{ member.phone || '-' }}
                                    </span>

                                </div>
                                <span
                                    class="inline-flex items-center bg-yellow-50/80 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 px-3 py-1 rounded-[0.5rem] text-[11px] font-semibold border border-yellow-200/80 dark:border-yellow-800/50 hover:bg-yellow-100 transition-colors">
                                    {{ member.feeName }}
                                </span>
                            </div>

                            <!-- License Plate -->
                            <div class="w-full flex flex-wrap gap-2 pt-2 lg:pt-0">
                                <ng-container
                                    *ngIf="member.memberVehicles && member.memberVehicles.length > 0; else noCar">
                                    <div *ngFor="let vehicle of member.memberVehicles"
                                        class="flex flex-col items-center bg-gray-50 dark:bg-slate-800 border-1 border-gray-200 dark:border-slate-600 rounded-lg px-3 py-1.5 shadow-[inset_0_2px_4px_rgba(0,0,0,0.02)] hover:shadow-md relative overflow-hidden group-hover:border-amber-300 dark:group-hover:border-amber-500/80 transition-all w-max min-w-[100px] cursor-default">
                                        <span
                                            class="text-[10px] text-gray-500 dark:text-gray-400 group-hover:text-amber-600 font-medium tracking-widest leading-none">{{
                                            vehicle.province }}</span>
                                        <span
                                            class="text-sm font-semibold text-gray-600 dark:text-slate-100 group-hover:text-amber-600 tracking-tight mt-1 leading-none">{{
                                            vehicle.license }}</span>
                                    </div>
                                </ng-container>
                                <ng-template #noCar>
                                    <span
                                        class="inline-flex items-center px-3 py-1.5 rounded-lg bg-gray-50 dark:bg-slate-700/30 text-gray-400 dark:text-slate-500 text-xs font-medium border border-dashed border-gray-200 dark:border-slate-600">
                                        ไม่มีรถ
                                    </span>
                                </ng-template>
                            </div>

                            <!-- Duration -->
                            <div class="w-full flex flex-row lg:flex-col gap-2 pt-2 lg:pt-0">
                                <div
                                    class="flex items-center gap-2.5 px-3 py-1 w-max shadow group-hover:shadow-yellow-600/50 rounded-lg">
                                    <div class="w-1.5 h-1.5 rounded-full bg-emerald-500 flex-shrink-0 animate-pulse">
                                    </div>
                                    <span
                                        class="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase w-auto">เริ่ม</span>
                                    <span
                                        class="text-[11px] font-bold text-slate-700 dark:text-slate-300 font-mono translate-y-[0.5px]">{{
                                        member.memberStartDate | date:'dd/MM/yy' }}</span>
                                </div>
                                <div
                                    class="flex items-center gap-2.5 px-3 py-1 w-max shadow group-hover:shadow-yellow-600/50  rounded-lg">
                                    <div class="w-1.5 h-1.5 rounded-full bg-red-500 flex-shrink-0"></div>
                                    <span
                                        class="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase w-auto">สิ้นสุด</span>
                                    <span
                                        class="text-[11px] font-bold text-slate-700 dark:text-slate-300 font-mono translate-y-[0.5px]">{{
                                        member.memberEndDate | date:'dd/MM/yy' }}</span>
                                </div>
                            </div>

                            <!-- Price -->
                            <div
                                class="w-full lg:text-right flex lg:flex-col lg:justify-center items-center lg:items-end justify-between pt-4 lg:pt-0 border-t border-gray-100 lg:border-none dark:border-slate-700">
                                <span class="lg:hidden text-[11px] font-bold text-gray-400 uppercase">ราคา (FEE)</span>
                                <span
                                    class="inline-flex items-center font-black text-amber-600 dark:text-amber-400 text-md tracking-tight bg-amber-50/60 dark:bg-amber-900/20 px-3 py-1.5 rounded-[0.75rem] border border-amber-100/60 dark:border-amber-800/30 group-hover:-translate-y-0.5 group-hover:shadow-sm transition-all origin-right w-max h-max">
                                    {{ memberLineTotal(member) | number:'1.2-2' }}
                                    <span *ngIf="member.memberVehicles.length  > 1"
                                        class="text-[10px] font-bold text-amber-600/80 dark:text-amber-400/80 ml-1">
                                        ×{{ member.memberVehicles.length }}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Footer Summary -->
                    <div
                        class="bg-gradient-to-r from-gray-50 to-gray-100/50 dark:from-slate-800/80 dark:to-slate-800/40 border-t border-gray-100 dark:border-slate-700/80 px-6 py-4 flex justify-end items-center gap-4 shadow-[inset_0_2px_4px_rgba(0,0,0,0.02)]">
                        <span class="text-sm font-medium text-gray-600 dark:text-slate-400 flex items-center gap-2">
                            จำนวนสมาชิกทั้งหมด
                            <span
                                class="inline-flex items-center justify-center bg-amber-500/70 dark:bg-white text-white dark:text-slate-900 rounded-lg px-3 py-1 text-sm font-bold shadow-md transform hover:scale-105 transition-transform cursor-default">
                                {{ data?.cityParkingRegisterDetailMemberGroupResponse?.length || 0 }}
                            </span>
                            รายการ
                        </span>
                    </div>

                </div>

                <!-- Payment / Transfer slip -->
                <div *ngIf="data && (isTransferPayment || data.financeId)"
                    class="bg-white dark:bg-slate-800/80 rounded-[1.5rem] shadow-sm border border-gray-100 dark:border-slate-700/60 p-6 mb-5 space-y-5">
                    <h4 class="text-lg font-bold text-gray-800 dark:text-white flex items-center gap-3">
                        <span class="w-1.5 h-6 bg-yellow-500/50 rounded-full"></span>
                        การชำระเงิน
                    </h4>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div class="space-y-1.5">
                            <p class="text-[11px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest">
                                ช่องทางการชำระ</p>
                            <p class="text-sm font-semibold text-gray-900 dark:text-slate-200">{{ data.feeTypeName || '-' }}</p>
                        </div>
                        <div class="space-y-1.5" *ngIf="isTransferPayment">
                            <p class="text-[11px] font-bold text-gray-400 dark:text-slate-500 uppercase tracking-widest">
                                บัญชีที่รับโอน</p>
                            <p class="text-sm font-semibold text-gray-900 dark:text-slate-200">{{ data.bankName || '-' }}</p>
                        </div>
                    </div>

                    <div *ngIf="requiresTransferSlip" class="space-y-2">
                        <label class="text-sm font-bold text-gray-700 dark:text-slate-300">
                            หลักฐานการโอนเงิน <span class="text-red-500">*</span>
                        </label>

                        <label *ngIf="!slipBase64"
                            class="flex flex-col items-center justify-center gap-1 py-8 rounded-xl border-2 border-dashed border-amber-300 dark:border-amber-700/60 bg-amber-50/40 dark:bg-amber-900/10 cursor-pointer hover:border-amber-500 transition-colors">
                            <span class="material-icons text-3xl text-amber-500">upload_file</span>
                            <span class="text-sm font-semibold text-amber-700 dark:text-amber-400">คลิกเพื่อแนบสลิปการโอน</span>
                            <span class="text-xs text-gray-400">PNG หรือ JPG (ไม่เกิน 5MB)</span>
                            <input type="file" class="hidden" accept="image/png,image/jpeg,image/webp"
                                (change)="onSlipFileChange($event)" />
                        </label>

                        <div *ngIf="slipBase64"
                            class="flex items-center gap-4 p-3 rounded-xl border border-gray-200 dark:border-slate-700 bg-gray-50/60 dark:bg-slate-900/40">
                            <img [src]="slipBase64" alt="Transfer slip"
                                class="h-24 w-20 object-contain rounded-lg bg-white border border-gray-100" />
                            <div class="flex-1 min-w-0">
                                <p class="text-sm font-semibold text-gray-800 dark:text-slate-200 truncate">{{ slipFileName }}</p>
                                <p class="text-xs text-gray-400">จะอัปโหลดเมื่อกดยืนยัน</p>
                            </div>
                            <button type="button" (click)="clearSlip()" [disabled]="isProcessing"
                                class="px-3 py-1.5 rounded-lg border border-red-200 text-xs font-bold text-red-600 hover:bg-red-50 disabled:opacity-50">
                                ลบ
                            </button>
                        </div>
                    </div>

                    <app-finance-attachments *ngIf="data.status === 2 && data.financeId" [financeId]="data.financeId"
                        [siteId]="data.siteId" [userId]="userId" title="หลักฐานการชำระเงิน">
                    </app-finance-attachments>
                </div>

                <!-- Remark Input & Footer Merge -->
                <div class="bg-gray-50/80 dark:bg-slate-800/90 border-t border-gray-200/80 dark:border-slate-700/80 backdrop-blur-md rounded-xl shadow"
                    *ngIf="!isLoading && data">

                    <div class="px-8 py-5">
                        <label class="flex items-center gap-2 text-sm font-bold text-gray-700 dark:text-slate-300 mb-3">
                            <svg class="w-4 h-4 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            หมายเหตุ (Remark)
                        </label>
                        <div class="relative group">
                            <!-- Glow effect matching amber theme -->
                            <div
                                class="absolute -inset-0.5 bg-gradient-to-r from-yellow-400 to-amber-500 rounded-xl blur opacity-0 group-focus-within:opacity-30 transition duration-500">
                            </div>
                            <textarea [(ngModel)]="remark" rows="2" [disabled]="data.status !== 1"
                                class="relative w-full px-5 py-3 bg-white dark:bg-slate-900/80 border border-gray-300 dark:border-slate-600 text-gray-900 dark:text-white rounded-xl focus:ring-0 focus:border-amber-400 outline-none transition-all placeholder-gray-400 dark:placeholder-slate-500 shadow-sm disabled:bg-gray-100/50 disabled:cursor-not-allowed custom-scrollbar resize-none"
                                placeholder="ระบุหมายเหตุเพิ่มเติม (ถ้ามี)..."></textarea>
                        </div>
                    </div>

                    <!-- Actions -->
                    <div
                        class="px-8 py-5 border-t border-gray-200/50 dark:border-slate-700/50 flex flex-col-reverse sm:flex-row sm:justify-between gap-4 bg-white/50 dark:bg-slate-900/30 rounded-b-xl">
                        <button type="button" [disabled]="isProcessing || !id" (click)="openActivityHistory()"
                            class="w-full sm:w-auto inline-flex justify-center items-center px-6 py-2.5 border border-slate-200 dark:border-slate-700 text-sm font-bold rounded-xl text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-800 
                            hover:border-amber-400 hover:text-amber-600 transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed">
                            <span class="material-icons text-[18px] mr-1.5">history</span>
                            ดูประวัติ
                        </button>

                        <div class="flex flex-col-reverse sm:flex-row sm:justify-end gap-4 w-full sm:w-auto">
                        <ng-container *ngIf="data.status === 1">
                            <button type="button" [disabled]="isProcessing" (click)="onDelete()"
                                class="w-full sm:w-auto inline-flex justify-center items-center px-6 py-2.5 border border-red-200 dark:border-red-900/50 text-sm font-bold rounded-xl text-red-600 dark:text-red-400 bg-white dark:bg-slate-800 
                                hover:bg-red-50 dark:hover:bg-red-900/30 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all hover:-translate-y-0.5 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none">
                                <svg class="w-4 h-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                ยกเลิกข้อมูล
                            </button>

                            <button type="button" [disabled]="isProcessing" (click)="onConfirm()"
                                class="relative w-full sm:w-auto inline-flex justify-center items-center px-8 py-2.5 border border-emerald-400/80 dark:border-emerald-500/50 text-sm font-bold rounded-xl text-white bg-emerald-500/90 
                                hover:bg-emerald-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-all shadow-emerald-500/50 hover:shadow-emerald-500/50 hover:-translate-y-0.5 disabled:opacity-80 disabled:cursor-wait disabled:transform-none disabled:shadow-none overflow-hidden group">
                                <ng-container *ngIf="isProcessing; else normalState">
                                    <svg class="animate-spin -ml-1 mr-2.5 h-4 w-4 text-emerald-100"
                                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                            stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                        </path>
                                    </svg>
                                    <span class="animate-pulse">กำลังสื่อสารกับ API...</span>
                                </ng-container>

                                <ng-template #normalState>
                                    <svg class="w-4 h-4 mr-1.5 transition-transform group-hover:scale-110" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M5 13l4 4L19 7" />
                                    </svg>
                                    ยืนยันฉบับร่าง
                                </ng-template>
                            </button>
                        </ng-container>

                        <button *ngIf="data.status === 2" type="button" [disabled]="isProcessingPdf"
                            (click)="printPdf()"
                            class="w-full sm:w-auto inline-flex justify-center items-center px-6 py-2.5 border border-red-200 dark:border-red-900/50 text-sm font-bold rounded-xl text-red-600 dark:text-red-400 bg-white dark:bg-slate-800 
                            hover:bg-red-50 dark:hover:bg-red-900/30 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all hover:-translate-y-0.5 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none">
                            <span class="material-icons text-[18px] mr-1.5">picture_as_pdf</span>
                            พิมพ์ PDF
                        </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Loading State -->
            <div class="px-6 py-32 flex justify-center items-center" *ngIf="isLoading">
                <div class="flex flex-col items-center gap-5">
                    <div class="relative">
                        <!-- Outer rotating border -->
                        <div
                            class="w-16 h-16 border-4 border-amber-100 dark:border-amber-900/30 rounded-full animate-spin border-t-amber-500 dark:border-t-amber-500 shadow-xl shadow-amber-500/20">
                        </div>
                        <!-- Inner pulse effect -->
                        <div
                            class="absolute inset-0 border-4 border-transparent rounded-full animate-ping border-t-amber-400/50 animation-delay-300">
                        </div>
                    </div>
                    <p
                        class="text-amber-600 dark:text-amber-400 text-sm font-bold tracking-widest uppercase animate-pulse">
                        กำลังโหลดข้อมูล...</p>
                </div>
            </div>
        </div>
    </div>

    <!---------------------------------------------- Confirm Modal ---------------------------------------------->
    <div *ngIf="showConfirmModal" class="fixed inset-0 z-[60] overflow-y-auto" aria-labelledby="modal-title"
        role="dialog" aria-modal="true">
        <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <!-- Overlay -->
            <div class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity duration-300 ease-out"
                [class.opacity-100]="isConfirmVisible" [class.opacity-0]="!isConfirmVisible"
                (click)="closeConfirmModal()">
            </div>

            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <!-- Confirm Modal Panel -->
            <div class="relative inline-block align-bottom bg-white dark:bg-slate-800 rounded-[2rem] text-left overflow-hidden shadow-2xl shadow-amber-500/20 transform transition-all duration-300 ease-out sm:my-8 sm:align-middle sm:max-w-lg w-full border border-gray-100 dark:border-slate-700"
                [class.opacity-100]="isConfirmVisible" [class.opacity-0]="!isConfirmVisible"
                [class.translate-y-0]="isConfirmVisible" [class.translate-y-4]="!isConfirmVisible"
                [class.sm:scale-100]="isConfirmVisible" [class.sm:scale-95]="!isConfirmVisible">
                <!-- Top brand line -->
                <div class="absolute top-0 w-full h-2 bg-gradient-to-r from-yellow-400 to-amber-500"></div>

                <div class="px-6 pt-8 pb-6 sm:p-8 sm:pb-6">
                    <div class="sm:flex sm:items-start">
                        <div
                            class="mx-auto flex-shrink-0 flex items-center justify-center h-14 w-14 rounded-full bg-amber-100 dark:bg-amber-900/50 sm:mx-0 sm:h-12 sm:w-12 shadow-inner border border-amber-200/50 dark:border-amber-800/50">
                            <svg class="h-6 w-6 text-amber-600 dark:text-amber-400" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div class="mt-4 text-center sm:mt-0 sm:ml-5 sm:text-left w-full">
                            <h3 class="text-xl font-bold text-gray-900 dark:text-white" id="modal-title">
                                ยืนยันการทำรายการ
                            </h3>
                            <div class="mt-3">
                                <p class="text-sm text-gray-600 dark:text-slate-400 leading-relaxed">
                                    คุณต้องการยืนยันข้อมูลและดำเนินการต่อใช่หรือไม่?
                                </p>
                                <!-- Show remark text if exists -->
                                <div *ngIf="remark"
                                    class="mt-3 bg-gray-50 dark:bg-slate-900/50 rounded-lg p-3 border border-gray-100 dark:border-slate-700/50">
                                    <p class="text-xs font-bold text-gray-700 dark:text-slate-300 mb-1">หมายเหตุ:</p>
                                    <p class="text-sm text-gray-500 dark:text-slate-400 italic">"{{ remark }}"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Actions -->
                <div
                    class="bg-gray-50/80 dark:bg-slate-900/50 px-6 py-4 sm:px-8 sm:py-5 flex flex-col-reverse sm:flex-row sm:justify-end gap-3 border-t border-gray-100 dark:border-slate-700/80">
                    <button type="button" (click)="closeConfirmModal()"
                        class="w-full sm:w-auto inline-flex justify-center items-center rounded-xl border border-gray-300 dark:border-slate-600 px-6 py-2.5 bg-white dark:bg-slate-800 text-sm font-bold text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-all shadow-sm">
                        ยกเลิก
                    </button>
                    <button type="button" (click)="confirmAction()"
                        class="w-full sm:w-auto inline-flex justify-center items-center rounded-xl border border-transparent px-8 py-2.5 bg-gradient-to-r from-yellow-500 to-amber-500 text-sm font-bold text-white hover:from-yellow-400 hover:to-amber-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-all shadow-md shadow-amber-500/30 hover:-translate-y-0.5">
                        ยืนยันรายการ
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!---------------------------------------------- Delete Modal ---------------------------------------------->
    <div *ngIf="showDeleteModal" class="fixed inset-0 z-[60] overflow-y-auto" aria-labelledby="modal-title"
        role="dialog" aria-modal="true">
        <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <!-- Overlay -->
            <div class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity duration-300 ease-out"
                [class.opacity-100]="isDeleteVisible" [class.opacity-0]="!isDeleteVisible" (click)="closeDeleteModal()">
            </div>

            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <!-- Delete Modal Panel -->
            <div class="relative inline-block align-bottom bg-white dark:bg-slate-800 rounded-[2rem] text-left overflow-hidden shadow-2xl shadow-red-500/10 transform transition-all duration-300 ease-out sm:my-8 sm:align-middle sm:max-w-lg w-full border border-gray-100 dark:border-slate-700"
                [class.opacity-100]="isDeleteVisible" [class.opacity-0]="!isDeleteVisible"
                [class.translate-y-0]="isDeleteVisible" [class.translate-y-4]="!isDeleteVisible"
                [class.sm:scale-100]="isDeleteVisible" [class.sm:scale-95]="!isDeleteVisible">
                <!-- Top brand line with red/rose gradient for destructive action -->
                <div class="absolute top-0 w-full h-2 bg-gradient-to-r from-red-500 to-rose-500"></div>

                <div class="px-6 pt-8 pb-6 sm:p-8 sm:pb-6">
                    <div class="sm:flex sm:items-start">
                        <div
                            class="mx-auto flex-shrink-0 flex items-center justify-center h-14 w-14 rounded-full bg-red-100 dark:bg-red-900/50 sm:mx-0 sm:h-12 sm:w-12 shadow-inner border border-red-200/50 dark:border-red-800/50">
                            <svg class="h-6 w-6 text-red-600 dark:text-red-400" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                        </div>
                        <div class="mt-4 text-center sm:mt-0 sm:ml-5 sm:text-left w-full">
                            <h3 class="text-xl font-bold text-gray-900 dark:text-white" id="modal-title">
                                ยืนยันการยกเลิกข้อมูล</h3>
                            <div class="mt-3">
                                <p class="text-sm text-gray-600 dark:text-slate-400 leading-relaxed">
                                    คุณต้องการยกเลิกข้อมูลนี้ใช่หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้
                                </p>
                                <div *ngIf="remark"
                                    class="mt-3 bg-gray-50 dark:bg-slate-900/50 rounded-lg p-3 border border-gray-100 dark:border-slate-700/50">
                                    <p class="text-xs font-bold text-gray-700 dark:text-slate-300 mb-1">
                                        หมายเหตุการยกเลิก:
                                    </p>
                                    <p class="text-sm text-gray-500 dark:text-slate-400 italic">"{{ remark }}"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Actions -->
                <div
                    class="bg-gray-50/80 dark:bg-slate-900/50 px-6 py-4 sm:px-8 sm:py-5 flex flex-col-reverse sm:flex-row sm:justify-end gap-3 border-t border-gray-100 dark:border-slate-700/80">
                    <button type="button" (click)="closeDeleteModal()"
                        class="w-full sm:w-auto inline-flex justify-center items-center rounded-xl border border-gray-300 dark:border-slate-600 px-6 py-2.5 bg-white dark:bg-slate-800 text-sm font-bold text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all shadow-sm">
                        ปิด
                    </button>
                    <button type="button" (click)="confirmDelete()"
                        class="w-full sm:w-auto inline-flex justify-center items-center rounded-xl border border-transparent px-8 py-2.5 bg-gradient-to-r from-red-600 to-rose-600 text-sm font-bold text-white hover:from-red-500 hover:to-rose-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all shadow-md shadow-red-500/30 hover:-translate-y-0.5">
                        ยืนยันการยกเลิก
                    </button>
                </div>
            </div>
        </div>
    </div>

    <app-modal-invoice-pdf-viewer *ngIf="showPdfModal" [pdfSrc]="pdfSrc"
        [modalTitle]="'รายงานรายละเอียดทะเบียนสมาชิก (PDF Preview)'"
        [downloadFileName]="'register-parking-' + id + '.pdf'" (close)="closePdfModal()">
    </app-modal-invoice-pdf-viewer>

    <app-modal-admin-activity-history
      *ngIf="showActivityHistory && id"
      [entityType]="activityEntityTypes.RegisterMemberGroup"
      [entityId]="id"
      title="ประวัติกลุ่มลงทะเบียนจอดรถ"
      [subtitle]="'#' + id"
      (close)="closeActivityHistory()">
    </app-modal-admin-activity-history>